export enum DefaultGameEnum {
  final_round_order = 5,
  round_point_value = 7
}
